import React, {Component} from "react"
import {MenuItem} from "react-bootstrap"
import {FormattedMessage} from "@irati/utils/lang"
import {Vote} from "@irati/types"
import MenuActions, {MenuActionsProps} from "../../../shared/MenuActions"

interface Props extends Partial<MenuActionsProps> {
  vote: Vote,
  onClickEdit: () => void,
  onClickRemove: () => void
}

class VoteActions extends Component<Props> {
  render() {
    const {vote, onClickEdit, onClickRemove, ...props} = this.props

    return (
      <MenuActions item={vote} {...props}>
        {({isUserContent, isAdmin}) => ([
          isUserContent && !vote.moderated && (
            <MenuItem key={1} onSelect={onClickEdit}>
              <FormattedMessage id="recognition.popup.votes.actions.edit" />
            </MenuItem>
          ),
          !isUserContent && !vote.moderated && isAdmin && (
            <MenuItem key={2} onSelect={onClickRemove}>
              <FormattedMessage id="recognition.popup.votes.action.delete" />
            </MenuItem>
          )
        ])}
      </MenuActions>
    )
  }
}

export default VoteActions
